import { Injectable } from "@angular/core";
import { Analytics, logEvent } from "@angular/fire/analytics";
import { environment } from '../../environments/environment';



@Injectable({ providedIn: 'root' })
export class SessionService {
  private sessionStart: number = 0;
  private sessionId:    string = '';
  private heartbeat:    any;

  private readonly env      = environment.appEnv;
  private readonly SESSION_KEY = 'lexiz_lawyers_session';

  constructor(private analytics: Analytics) {}

  // init() {
  //   console.log('SessionService initialized');
  //   this.recoverCrashedSession();   // recover any lost session
  //   this.startSession();            // start new session
  //   this.listenToVisibility();      // handle tab switch/mobile
  // }

  // private startSession() {
  //   console.log('Starting session');
  //   this.sessionStart = Date.now();
  //   this.sessionId    = `sess_${this.sessionStart}`;
  //   this.saveToLocalStorage();
  //   // this.startHeartbeat();
  //   console.log('Event fired');
  // }

  // // private startHeartbeat() {
  // //   clearInterval(this.heartbeat);

  // //   this.heartbeat = setInterval(() => {
  // //     console.log('HEARTBEAT',new Date().toISOString());
  // //     this.saveToLocalStorage();
  // //     logEvent(this.analytics, 'session_heartbeat', {
  // //       session_id: this.sessionId,
  // //       elapsed_ms: Date.now() - this.sessionStart,
  // //       env: this.env,
  // //     });
  // //   }, 30000);
  // // }

  // private listenToVisibility() {
  //   document.addEventListener('visibilitychange', () => {
  //     if (document.visibilityState === 'hidden') {
  //       this.onAppHidden();
  //     } else {
  //       this.onAppVisible();
  //     }
  //   });
  // }

  // private onAppHidden() {
  //   clearInterval(this.heartbeat);
  //   logEvent(this.analytics, 'session_paused', {
  //     session_id: this.sessionId,
  //     elapsed_ms: Date.now() - this.sessionStart,
  //     env: this.env,
  //   });
  // }

  // private onAppVisible() {
  //   // this.startHeartbeat();
  //   logEvent(this.analytics, 'session_resumed', {
  //     session_id: this.sessionId,
  //     env: this.env,
  //   });
  // }

  // endSession() {
  //   console.log("END SESSION", this.heartbeat, new Date().toISOString())
  //   clearInterval(this.heartbeat);
  //   logEvent(this.analytics, 'app_session', {
  //     session_id:          this.sessionId,
  //     session_duration_ms: Date.now() - this.sessionStart,
  //     ended_cleanly:       true,
  //     env: this.env,
  //   });
  //   localStorage.removeItem(this.SESSION_KEY);
  //   console.log("END SESSION DONE")
  // }

  // private saveToLocalStorage() {
  //   localStorage.setItem(this.SESSION_KEY, JSON.stringify({
  //     session_id:    this.sessionId,
  //     session_start: this.sessionStart,
  //     last_seen:     Date.now()
  //   }));
  // }

  // private recoverCrashedSession() {
  //   console.log('get crashed session');
  //   const saved = localStorage.getItem(this.SESSION_KEY);
  //   console.log("crashed session",!saved);
  //   if (!saved) return;

  //   const s = JSON.parse(saved);
  //   logEvent(this.analytics, 'app_session', {
  //     session_id:          s.session_id,
  //     session_duration_ms: s.last_seen - s.session_start,
  //     ended_cleanly:       false,   // crashed session
  //     env: this.env
  //   });
  //   localStorage.removeItem(this.SESSION_KEY);
  // }
}